import { useState, useEffect } from "react"

import { medusaClient } from "@lib/config"

interface UpdatePaymentSessionProps {
  cartId: string | null
  loanUuid: string | null
  isPaymentSessionCreated: boolean
}

export const useUpdateCartPaymentSession = ({ cartId, loanUuid, isPaymentSessionCreated }: UpdatePaymentSessionProps) => {
  const [isuseUpdateCartPaymentSessionLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)
  const [isPaymentSessionUpdated, setIsPaymentSessionUpdated] = useState<boolean>(false)

  useEffect(() => {
    if (cartId && loanUuid && isPaymentSessionCreated) {
      const updatePaymentSession = async () => {
        setIsLoading(true)
        setError(null)

        try {
          await medusaClient.carts.updatePaymentSession(cartId, "nelo", {
            data: {
              loan_uuid: loanUuid,
            },
          })

          setIsPaymentSessionUpdated(true)
        } catch (err) {
          console.error("Failed to update payment session:", err)
          setError(err instanceof Error ? err : new Error("An unknown error occurred"))
        } finally {
          setIsLoading(false)
        }
      }

      updatePaymentSession()
    }
  }, [cartId, loanUuid, isPaymentSessionCreated])

  return { isuseUpdateCartPaymentSessionLoading, error, isPaymentSessionUpdated }
}
